package com.macrofocus.eflux.ui.morphing

import org.locationtech.jts.geom.LineString
import org.locationtech.jts.geom.LinearRing
import org.locationtech.jts.geom.Polygon
import org.locationtech.jts.simplify.DouglasPeuckerSimplifier

fun simplifyLine(line: LineString, tolerance: Double): LineString {
    // Simplify the LineString using Douglas-Peucker algorithm
    val simplified = DouglasPeuckerSimplifier.simplify(line, tolerance)
    return simplified as LineString
}

fun simplifyLine(line: LinearRing, tolerance: Double): LinearRing {
    // Simplify the LineString using Douglas-Peucker algorithm
    val simplified = DouglasPeuckerSimplifier.simplify(line, tolerance)
    return simplified as LinearRing
}

fun simplifyPolygon(line: Polygon, tolerance: Double): Polygon {
    // Simplify the LineString using Douglas-Peucker algorithm
    val simplified = DouglasPeuckerSimplifier.simplify(line, tolerance)
    return simplified as Polygon
}